import React, {useEffect, useState} from "react";
import "./Payment.scss";
import "../Basket/Basket.scss";
import {useHistory} from "react-router-dom";
import {
    StoreOnlineAddCoupons,
    StoreOnlineCoupons,
    StoreOnlineCreateInvoice,
    StoreOnlineFinal, StoreOnlineFinalCoupon,
    StoreOnlineGateWay
} from "./PaymentService";
import Rodal from "rodal";
import {GetBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import toaster from "toasted-notes";
import SwiperId from "react-id-swiper";
import {ConvertToJalali} from "../StoreDetail/StoreDetailServices";
import SimpleLineIcon from "react-simple-line-icons";
import CouponComponent from "../../Components/CouponComponent/CoponComponent";
import {AssignCoupon} from "../Home/HomeServices";
import {CouponData} from "../Menu/MenuServices";
import {Setup} from "../../Services";
import { Spin,Modal,Alert } from 'antd';
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {useResp} from "../../hooks";
import PaymentResponsive from "../PaymentResponsive/PaymentResponsive";


function RewardInInvoice({item}) {
    return(
        <div className="off-sub-section" style={{
            width:"100%",
            padding:"5px 20px"
        }}>
            <span> {numberWithCommas(item.effect.value)} ریال </span>
            <span>{item.effect.title}</span>
        </div>
    )

}


function convertPerToAm(per,max,amount) {
    console.log("per:",per)
    console.log("max:",max)
    console.log("amount:",amount)
    let price = amount*per/100;
    console.log("price : ",price)
    if(max>price){
        return numberWithCommas(price)
    }else {
        return numberWithCommas(max)
    }
}

function numberWithCommas(x) {
    if (x === 0) {
        return 0
    }
    if (x) {
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }
    return "-"
}

function Success(props) {
    return (
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Error(props) {

    return (
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Payment() {
    const history = useHistory();

    const [showModal, set_showModal] = useState(false)
    const [merchant, set_merchant] = useState({})
    const [basket, set_basket] = useState(false)
    const [coupon, set_coupon] = useState("")
    const [couponStatus, set_couponStatus] = useState(false)
    const [invoice, set_invoice] = useState(null)
    const [selectedGate, set_selectedGate] = useState(null)
    const [finalObj, set_finalObj] = useState(null)

    const [couponsList, set_couponsList] = useState([])

    const [loading, set_loading] = useState(false)


    useEffect(() => {
        getBasket();
        prePayProcess()
    }, [])

    const getCoupons = async (merchantId) => {
        const response = await StoreOnlineCoupons(merchantId);
        set_couponsList(response.data)
        // console.log("coupon : ",response);
    }

    const getBasket = async () => {
        try {
            const response = await GetBasket();
            // console.log("basket : ",response.data)
            set_basket(response.data);
            if (response.data.merchant) {
                getCoupons(response.data.merchant.uid);
                set_merchant(response.data.merchant)
            }
        } catch (e) {
            // console.log(e)
        }
    }


    const finalization = async () => {
        try {
            const response = await StoreOnlineFinal();
            return response.data
        } catch (e) {
            history.push(`/online-store-basket/${merchant.uid}`)
            // console.log(e)
            return false
        }
    }

    const finalizationCoupone = async (id) => {
        try {
            const response = await StoreOnlineFinalCoupon(id,finalObj.invoice.uid);
            return response.data
        } catch (e) {
            // console.log(e)
            toaster.notify(({onClose}) => (<Error message={"کد تخفیف قابل استفاده نمی باشد"}/>), {duration: 2000});
            return false
        }
    }

    const createInvoice = async (obj) => {
        try {
            const response = await StoreOnlineCreateInvoice(obj);
            return response.data
        } catch (e) {
            // console.log(e)
            return false
        }
    }


    const prePayProcess = async () => {
        set_loading(true)
        try {
            //finalization
            const final = await finalization();
            set_finalObj(final)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            console.log(e)
        }
    }

    const coupon_finalize = async (id) => {
        try {
            //finalization
            const final = await finalizationCoupone(id);
            if(final){
                set_finalObj(final)
                // set_couponsList(couponsList.filter(i=>i.code!==id))
                return true
            }
        } catch (e) {
            return false
            console.log(e)
        }
    }




    const redirectToGateWay = async () => {
        console.log("sssssssssssssssss")
        try {
            //create invoice
            let req = {
                amount: finalObj.invoice.payable_amount,
                client_callback: window.location.origin+"/online-order-detail/"+finalObj.invoice.uid,
                res_num: finalObj.invoice.uid,
                merchant_uid: finalObj.invoice.merchant.uid
                // acceptor: finalObj.invoice.merchant.acceptor
            }

            const mockInvoice = {
                "id": 152,
                "amount": 285144,
                "res_num": "BqWvfRtywx",
                "state": 1,
                "description": null,
                "created": "2023-07-01T12:50:49.823260+03:30",
                "is_payable": true,
                "sign": "f2d7a8528543f63da9fbd38fbf529f3a152",
                "type": 1,
                "client_callback": "https://test.apluss.ir/online-order-detail/BqWvfRtywx",
                "courier_cost": 0,
                "tax_cost": 23544,
                "packing_cost": 0,
                "ipg": [
                    {
                        "id": 1,
                        "name": "saman",
                        "persian_name": "Saman",
                        "icon": "http://test.apluss.ir/static/gateway/saman.png",
                        "is_default": true
                    },
                    {
                        "id": 2,
                        "name": "fake",
                        "persian_name": "fake",
                        "icon": "http://test.apluss.ir/static/gateway/saman.png",
                        "is_default": false
                    }
                ]
            }
             const response = await StoreOnlineCreateInvoice(req);
             history.push("/online-store-gateway", {create: response.data})
            // history.push("/online-store-gateway", {create: mockInvoice})
        } catch (e) {
            // console.log(e)
            return
        }
        // console.log(selectedGate,invoice.sign)
        // if(selectedGate && invoice && invoice.sign){
        //     try{
        //         const response = await StoreOnlineGateWay(selectedGate,invoice.sign)
        //         console.log("go to gateway",response)
        //         document.location.href=response.data.url
        //     }catch (e) {
        //         console.log(e)
        //     }
        // }else {
        //     toaster.notify(({ onClose }) => (<Error   message={"لطفا یک درگاه را انتخاب نمایید"}/>),{duration: 2000});
        // }
    }

    const params = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        rtl: true,
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 40
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 30
            },
            400: {
                slidesPerView: 'auto',
                spaceBetween: 20
            },
            320: {
                slidesPerView: 'auto',
                spaceBetween: 10
            }
        }
    }


    const addCoupon = async () => {
        if (basket && basket.merchant) {
            if (!couponStatus) {
                set_couponStatus(true)
                try {
                    // const response = await StoreOnlineAddCoupons(basket.merchant.uid, {coupon: coupon});
                    const cop_response = await CouponData(coupon);
                    let response= await AssignCoupon(cop_response.data.uid);
                    console.log("coupon : ", response);
                    set_couponStatus(false)
                    toaster.notify(({onClose}) => (<Success message={"کد تخفیف برای سفارش شما ثبت شد"}/>), {duration: 2000});
                    getCoupons(merchant.uid);
                    set_showModal(false)
                } catch (e) {
                    console.log("coupon error  : ", e.response.status);
                    set_couponStatus(false)
                    toaster.notify(({onClose}) => (<Error message={"کد تخفیف معتبر نمی باشد"}/>), {duration: 2000});
                }
            }
        }
    }

    const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);

    const showPaymentModal = () => {
        setIsPaymentModalVisible(true);
    };

    const handlePaymentOk = () => {
        setIsPaymentModalVisible(false);
    }

    const handlePaymentCancel = () => {
        setIsPaymentModalVisible(false);
    };

    const { height, width,mobileWidth } = useWindowDimensions();
    const resp = useResp()

    return (
        <>
            {resp?<PaymentResponsive
                showModal={showModal}
                set_coupon={set_coupon}
                coupon={coupon}
                couponStatus={couponStatus}
                addCoupon={addCoupon}
                set_showModal={set_showModal} coupon_finalize={coupon_finalize}  couponsList={couponsList} finalObj={finalObj} redirectToGateWay={redirectToGateWay}/>:null}
            {!resp?<div className="payment-container" style={{paddingBottom:100}}>
                <Modal footer={null} visible={isPaymentModalVisible} onOk={handlePaymentOk} onCancel={handlePaymentCancel}>
                    <div className="payment-modal-sec">
                        <p>لطفا نوع خرید را انتخاب نمایید </p>
                        <div className="payment-modal-item">
                            <span>پرداخت در محل</span>
                            <input type="radio" name="m1" id=""/>
                        </div>
                        <div className="payment-modal-item">
                            <span>پرداخت توسط درگاه</span>
                            <input type="radio" name="m1" id=""/>
                        </div>

                        <div className="payment-modal-btn">
                        <span onClick={()=>{
                            history.push('/reward')
                        }}>ارسال</span>
                        </div>
                    </div>
                </Modal>
                <div className="pay-ww">
                    <Spin spinning={loading} tip="لطفا کمی صبر نمایید ... " >
                        <div className="basket-brand" >
                            <img src={merchant.thumbnail} alt=""/>
                        </div>
                        <div className="payment-wr">
                            <Rodal
                                customStyles={{
                                    height: 'auto !important',
                                    bottom: 'auto',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '300px'
                                }}
                                animation={"zoom"} visible={showModal} onClose={() => set_showModal(false)}>
                                <div className="coupons_modal">
                                    <span className="modal-title">کد تخفیف خود را وارد نمایید </span>
                                    <input type="text"
                                           onChange={(e) => {
                                               set_coupon(e.target.value)
                                           }}
                                           value={coupon}
                                           name="" id="" placeholder="کد تخفیف"/>
                                    <span className="modal-btn" onClick={() => {
                                        addCoupon();
                                    }}>
                        {couponStatus ? "... در حال ثبت" : "ثبت"}
                        </span>
                                </div>
                            </Rodal>
                            <div className="online-header-section">
                                <i className="fa fa-arrow-left"
                                   onClick={() => {
                                       history.goBack()
                                   }}
                                ></i>
                                <span>اطلاعات پرداخت</span>
                            </div>

                            <div className="basket-info-section">
                                <div className="total-section">
                                    <span>{finalObj && finalObj.invoice && finalObj.invoice.merchant.name}</span>
                                    <span>پذیرنده</span>
                                </div>
                                <div className="price-section">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.order.original_amount)} ریال </span>
                                    <span>مبلغ فاکتور</span>
                                </div>
                                <div className="price-section">
                                    <span> {finalObj && finalObj.invoice && finalObj.invoice.courier_cost && numberWithCommas(finalObj.invoice.courier_cost)} ریال </span>
                                    <span>هزینه پیک</span>
                                </div>
                                <div className="price-section">
                                    <span> {finalObj && finalObj.invoice && finalObj.invoice.packing_cost && numberWithCommas(finalObj.invoice.packing_cost)} ریال </span>
                                    <span>هزینه بسته بندی</span>
                                </div>
                                <div className="price-section">
                                    <span> {finalObj && finalObj.invoice && finalObj.invoice.tax_cost && numberWithCommas(finalObj.invoice.tax_cost)} ریال </span>
                                    <span>مالیات بر ارزش افزوده</span>
                                </div>
                                <div className="off-section indent-item">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.order.discount)} ریال </span>
                                    <span>تخفیف اقلام</span>
                                </div>
                                <div className="off-section indent-item">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.discount_amount)} ریال </span>
                                    <span>تخفیف کوپن</span>
                                </div>


                                {/*{finalObj && finalObj.rewards.map(j=>{*/}
                                {/*    return(*/}
                                {/*      <RewardInInvoice item={j}/>*/}
                                {/*    )*/}
                                {/*})}*/}

                                {finalObj && finalObj.invoice.coupon ?
                                    <div className="off-sub-section" >
                                        {finalObj.invoice.coupon.coupon_type==="discount_percent"?
                                            <span> {convertPerToAm(
                                                finalObj.invoice.coupon.discount_value,
                                                finalObj.invoice.coupon.max_discount_amount,
                                                finalObj.invoice.amount
                                            )} ریال </span>:
                                            <span> {numberWithCommas(finalObj.invoice.coupon.discount_value)} ریال </span>
                                        }

                                        <span>{finalObj.invoice.coupon.title}</span>
                                    </div>:null
                                }

                                <div className="off-section">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.discount_amount+finalObj.invoice.order.discount)} ریال </span>
                                    <span>مجموع تخفیف</span>
                                </div>

                                <div className="price-section">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.payable_amount)} ریال </span>
                                    <span>مبلغ قابل پرداخت</span>
                                </div>


                                {finalObj && finalObj.rewards && finalObj.rewards.length>0?<div className="invoice-reward-t-sec">
                                    <div className="invoice-reward-t-header">
                                        <span>پاداش های شما از این خرید</span>
                                        <i className="fa fa-gift"></i>
                                    </div>
                                    {finalObj && finalObj.rewards.map(j=>{
                                        return(
                                            <RewardInInvoice item={j}/>
                                        )
                                    })}
                                </div>:null}

                            </div>


                            {/*<div className="ipg-section">*/}
                            {/*    <div className="ipg-title">*/}
                            {/*        <span>*/}
                            {/*            لطفا یک درگاه را انتخاب نمایید*/}
                            {/*        </span>*/}
                            {/*    </div>*/}
                            {/*    {invoice && invoice.ipg.map(item=>{*/}
                            {/*        return(*/}
                            {/*            <div className="ipg-item">*/}
                            {/*                <span>{item.persian_name}</span>*/}
                            {/*                <img src={item.icon} alt=""/>*/}
                            {/*                <input*/}
                            {/*                    onClick={()=>{*/}
                            {/*                        set_selectedGate(item.name)*/}
                            {/*                    }}*/}
                            {/*                    type="radio" name="ipg" id=""/>*/}
                            {/*            </div>*/}
                            {/*        )*/}
                            {/*    })}*/}

                            {/*</div>*/}

                            <div className="ticket-section">
                                <div className="add-ticket-section" onClick={() => {
                                    set_showModal(true)
                                }}>
                                    <span> وارد کردن کد تخفیف </span>
                                    <i className="fa fa-plus"></i>
                                </div>
                                <div className="title-section">
                                    : کوپن های شما در این فروشگاه
                                </div>
                            </div>


                            {/*{couponsList.length>0?<div className="warning-box">*/}
                            {/*    <Alert*/}
                            {/*        description="بعد از انتخاب و اعمال کوپن در صورت خروج از صفحه پرداخت و یا برگشت به صفحه قبل , کوپن مورد نظر نامعتبر خواهد شد."*/}
                            {/*        type="warning"*/}
                            {/*        showIcon*/}
                            {/*        closable*/}
                            {/*    />*/}
                            {/*</div>:null}*/}



                            {finalObj && finalObj.rewards ? <div className="storeDetail-rewards">

                                {couponsList.map(i=>{
                                    return(
                                        <CouponComponent final={coupon_finalize} item={i}/>
                                    )
                                })}


                                {/*{finalObj.rewards.length > 0 ? <SwiperId {...params}>*/}
                                {/*    {finalObj.rewards.map(reward => {*/}
                                {/*        switch (reward.effect.effect) {*/}
                                {/*            case "increase_loyalty_points_per_amount":*/}
                                {/*                return (*/}
                                {/*                    <div key={reward.uid} className="slider-gift-section">*/}
                                {/*                        <div className="gift-section-ticket">*/}
                                {/*                            <div className="gift-section-ticket-off reward_level_2">*/}
                                {/*                            <span className="gift-section-ticket-off-number"><span*/}
                                {/*                                className="off-number">{reward.effect.value ? reward.effect.value : " 1000 "}</span> </span>*/}
                                {/*                                <span className="gift-section-ticket-off-label">ریال</span>*/}
                                {/*                            </div>*/}
                                {/*                            <div className="gift-section-ticket-info">*/}
                                {/*                                <div className="rotated-half-up-circle"></div>*/}
                                {/*                                <div className="rotated-half-down-circle"></div>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-title">{reward.campaign_title}</span>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-max">{reward.description}</span>*/}
                                {/*                                <div className="gift-section-ticket-info-date">*/}
                                {/*                                    <span>{ConvertToJalali(reward.created)}</span>*/}
                                {/*                                    <SimpleLineIcon name="clock"/>*/}
                                {/*                                </div>*/}
                                {/*                            </div>*/}
                                {/*                        </div>*/}
                                {/*                    </div>*/}
                                {/*                )*/}
                                {/*                break;*/}
                                {/*            case "increase_loyalty_points":*/}
                                {/*                return (*/}
                                {/*                    <div key={reward.uid} className="slider-gift-section">*/}
                                {/*                        <div className="gift-section-ticket">*/}
                                {/*                            <div className="gift-section-ticket-off reward_level_2">*/}
                                {/*                            <span className="gift-section-ticket-off-number"><span*/}
                                {/*                                className="off-number">{reward.effect.value ? reward.effect.value : " 0 "}</span></span>*/}
                                {/*                                <span className="gift-section-ticket-off-label">امتیاز وفاداری</span>*/}
                                {/*                            </div>*/}
                                {/*                            <div className="gift-section-ticket-info">*/}
                                {/*                                <div className="rotated-half-up-circle"></div>*/}
                                {/*                                <div className="rotated-half-down-circle"></div>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-title">{reward.campaign_title}</span>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-max">{reward.description}</span>*/}
                                {/*                                <div className="gift-section-ticket-info-date">*/}
                                {/*                                    <span>{ConvertToJalali(reward.created)}</span>*/}
                                {/*                                    <SimpleLineIcon name="clock"/>*/}
                                {/*                                </div>*/}
                                {/*                            </div>*/}
                                {/*                        </div>*/}
                                {/*                    </div>*/}
                                {/*                )*/}

                                {/*                break;*/}
                                {/*            case "generate_coupon_discount_percent":*/}
                                {/*                return (*/}
                                {/*                    <div key={reward.uid} className="slider-gift-section">*/}
                                {/*                        <div className="gift-section-ticket">*/}
                                {/*                            <div className="gift-section-ticket-off reward_level_2">*/}
                                {/*                            <span className="gift-section-ticket-off-number"><span*/}
                                {/*                                className="off-number">{reward.effect.value ? reward.effect.value : " 0 "}</span>%</span>*/}
                                {/*                                <span className="gift-section-ticket-off-label">تخفیف</span>*/}
                                {/*                            </div>*/}
                                {/*                            <div className="gift-section-ticket-info">*/}
                                {/*                                <div className="rotated-half-up-circle"></div>*/}
                                {/*                                <div className="rotated-half-down-circle"></div>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-title">{reward.campaign_title}</span>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-max">{reward.description}</span>*/}
                                {/*                                <div className="gift-section-ticket-info-date">*/}
                                {/*                                    <span>{ConvertToJalali(reward.created)}</span>*/}
                                {/*                                    <SimpleLineIcon name="clock"/>*/}
                                {/*                                </div>*/}
                                {/*                            </div>*/}
                                {/*                        </div>*/}
                                {/*                    </div>*/}
                                {/*                )*/}
                                {/*                break;*/}
                                {/*            case "real_time_discount_amount":*/}
                                {/*                return (*/}
                                {/*                    <div key={reward.uid} className="slider-gift-section">*/}
                                {/*                        <div className="gift-section-ticket">*/}
                                {/*                            <div className="gift-section-ticket-off reward_level_2">*/}
                                {/*                            <span className="gift-section-ticket-off-number"><span*/}
                                {/*                                className="off-number">{reward.effect.value ? reward.effect.value : " 1000 "}</span> </span>*/}
                                {/*                                <span className="gift-section-ticket-off-label">ریال</span>*/}
                                {/*                            </div>*/}
                                {/*                            <div className="gift-section-ticket-info">*/}
                                {/*                                <div className="rotated-half-up-circle"></div>*/}
                                {/*                                <div className="rotated-half-down-circle"></div>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-title">{reward.campaign_title}</span>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-max">{reward.description}</span>*/}
                                {/*                                <div className="gift-section-ticket-info-date">*/}
                                {/*                                    <span>{ConvertToJalali(reward.created)}</span>*/}
                                {/*                                    <SimpleLineIcon name="clock"/>*/}
                                {/*                                </div>*/}
                                {/*                            </div>*/}
                                {/*                        </div>*/}
                                {/*                    </div>*/}
                                {/*                )*/}
                                {/*                break;*/}
                                {/*            default:*/}
                                {/*                return (*/}
                                {/*                    <div key={reward.uid} className="slider-gift-section">*/}
                                {/*                        <div className="gift-section-ticket">*/}
                                {/*                            <div className="gift-section-ticket-off reward_level_2">*/}
                                {/*                            <span className="gift-section-ticket-off-number"><span*/}
                                {/*                                className="off-number">{reward.effect.value ? reward.effect.value : " 0 "}</span>%</span>*/}
                                {/*                                <span className="gift-section-ticket-off-label"> - </span>*/}
                                {/*                            </div>*/}
                                {/*                            <div className="gift-section-ticket-info">*/}
                                {/*                                <div className="rotated-half-up-circle"></div>*/}
                                {/*                                <div className="rotated-half-down-circle"></div>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-title">{reward.campaign_title}</span>*/}
                                {/*                                <span*/}
                                {/*                                    className="gift-section-ticket-info-max">{reward.description}</span>*/}
                                {/*                                <div className="gift-section-ticket-info-date">*/}
                                {/*                                    <span>{ConvertToJalali(reward.created)}</span>*/}
                                {/*                                    <SimpleLineIcon name="clock"/>*/}
                                {/*                                </div>*/}
                                {/*                            </div>*/}
                                {/*                        </div>*/}
                                {/*                    </div>*/}
                                {/*                )*/}

                                {/*        }*/}
                                {/*    })}*/}
                                {/*</SwiperId> : null}*/}

                            </div> : null}


                            <div className="online-product-footer" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                                <div className="notAdded-mode">
                                    <div className="add-to-basket-btn" onClick={() => {
                                        redirectToGateWay();
                                        //setIsPaymentModalVisible(true)
                                    }}>
                                        <span>پرداخت</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="online-product-footer-md">
                            <div className="notAdded-mode-md">
                                <div className="add-to-basket-btn" onClick={()=>{
                                    redirectToGateWay();
                                }}>
                                    <span>پرداخت</span>
                                </div>
                                <div className="add-to-basket-btn" onClick={()=>{
                                    history.goBack()
                                }}>
                                    <span>برگشت</span>
                                </div>
                            </div>
                        </div>
                    </Spin>
                </div>

            </div>:null}


            </>
    )
}


export {Payment};
